import React, { useEffect, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { GeneralType } from "../../../../lib/types";
import { openContentPopup } from "../../../../store/actions";

import { generals } from "../../../../assets/images/generals";
import GeneralEmptyCard from "../Generals/GeneralEmptyCard";
import { setSameHeight } from "../../../../lib/elementUtilities";
import { systemClass } from "../../../../lib/enums";

const mapStateToProps = (state: any) => ({
  canDoLabyrinth: state.governorate.canDoLabyrinth,
  turn: state.governorate.turn,
  labyrinthAttempt: state.governorate.labyrinthAttempt,
  labyrinthAttemptLimit: state.governorate.labyrinthAttemptLimit,
  generals: state.governorate.generals
})

const mapDispatchToProps = (dispatch: any) => ({
  openContentPopupDispatch:
    (contentPopupOptions: any) => dispatch(openContentPopup(contentPopupOptions))
});

const connector = connect(mapStateToProps, mapDispatchToProps);

const Labyrinth = ({
  canDoLabyrinth,
  turn,
  labyrinthAttempt,
  labyrinthAttemptLimit,
  generals: generalTypes,
  openContentPopupDispatch
}: ConnectedProps<typeof connector>) => {
  const generalsRef = useRef<HTMLDivElement>(null);

  let blocker: string | null = null;
  if (!canDoLabyrinth) {
    if (!generalTypes || !generalTypes.length) {
      blocker = "You don't have any general. Fortunately, there are possibilities to get some. Keep going on the quests.";
    } else if (labyrinthAttempt >= labyrinthAttemptLimit) {
      blocker = "You have exhausted all your attempts in labyrinth for today.";
    } else if (turn < 5) {
      blocker = "Labyrinth is not available until 5th turn.";
    }
  }

  useEffect(() => {
    setSameHeight(generalsRef.current || undefined);
  }, []);

  const generalsCount = generalTypes
    .reduce((count: number, generalType: GeneralType) => count += generalType.general ? 1 : 0, 0);

  return (
    <>
      <h2 className="h2 h2-first">
        <span className="bordered">Choose your general</span>
      </h2>
      <span className="divider"/>
      <section className="boxes-group">
        <div className="box text-info text-info-bigger">
          <p className="text-info text-center">
            Labyrinth attempt: {labyrinthAttempt}/{labyrinthAttemptLimit}&nbsp;
          </p>
          {blocker
          && <p className="text-center negative">
              {blocker}
            </p>
          }
        </div>
        <div className="box">
          <div ref={generalsRef} className="row persons generals">
            {generalTypes.map((g: GeneralType) => (g.general
              ? <div className="col-sm-6 col-md-3">
                <div className={`person ${systemClass.MatchHeight}`}>
                  <img
                    src={generals[`general${g.typeId}`]}
                    width={60}
                    height={70}
                    alt="general portrait"
                    className="photo"
                  />
                  <h3 className="name">{g.general && g.general.name}</h3>
                  <p>
                    <strong className="subname">{g.typeName}</strong>
                  </p>
                  <p>
                    <span className="white">Level</span>&nbsp;&nbsp;<em>{g.general && g.general.level}</em><br/>
                    <span className="white">Experience</span>&nbsp;&nbsp;<em>{g.general && g.general.experience}</em>
                  </p>
                  <a
                    href="#"
                    className={`btn btn-blank ${blocker ? "disabled" : ""}`}
                    onClick={() => !blocker && openContentPopupDispatch({
                      name: "ChooseTreasure",
                      title: "Labyrinth",
                      icon: "labyrint",
                      generalType: g,
                      generalsCount: generalTypes.filter((g1: GeneralType) => g1.general).length
                    })}
                  >
                    Choose
                  </a>
                </div>
              </div>
              : <GeneralEmptyCard
                key={g.typeName}
                typeId={g.typeId}
                typeName={g.typeName}
                sendToLabyrinth={false}
                zeroGenerals={!generalsCount}
              />))}
          </div>
        </div>

        <span className="divider"/>
      </section>
    </>
  )
}

export default connector(Labyrinth);
